module.exports = __webpack_public_path__ + "static/016-66dc9ffdb860462a2751f56356a1e246.jpg";